"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressBook = exports.ADDRESS_BOOK_PATH = void 0;
require("../../../scss/addressBook.scss");
const react_1 = __importStar(require("react"));
const router_1 = require("@reach/router");
const react_i18next_1 = require("react-i18next");
const boutik_gatsby_plugin_multilocale_1 = require("@sbi-international/boutik.gatsby.plugin.multilocale");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const customerAccountContext_1 = require("../../../contexts/customerAccountContext");
const constants_1 = require("../../../constants");
const AddressForm_1 = require("./AddressForm");
const CustomerAccount_1 = require("../../CustomerAccount");
const AddressBookListItem_1 = require("./AddressBookListItem");
const Button_1 = require("../../common/Button");
exports.ADDRESS_BOOK_PATH = "/address-book";
const AddressBook = () => {
    const { t } = (0, react_i18next_1.useTranslation)(constants_1.constants.TRANSLATIONS_NAMESPACE);
    const customerAccountContext = (0, react_1.useContext)(customerAccountContext_1.CustomerAccountContext);
    const { addresses } = customerAccountContext.actions;
    const [addressBook] = addresses.addressesHook();
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const { localizePath } = (0, boutik_gatsby_plugin_multilocale_1.usePageLocalization)();
    const getSortedCustomerAddresses = () => {
        let sortedAddresses = [...addressBook === null || addressBook === void 0 ? void 0 : addressBook.customerAddresses];
        sortedAddresses === null || sortedAddresses === void 0 ? void 0 : sortedAddresses.sort(function (a, b) {
            if (a.default_shipping && a.default_billing && (!b.default_shipping || !b.default_billing)) {
                return -1;
            }
            else if ((!a.default_shipping || !a.default_billing) && b.default_shipping && b.default_billing) {
                return 1;
            }
            else if ((a.default_shipping || a.default_billing) && !(b.default_shipping || b.default_billing)) {
                return -1;
            }
            else if (!(a.default_shipping || a.default_billing) && (b.default_shipping || b.default_billing)) {
                return 1;
            }
            else {
                return 0;
            }
        });
        setIsLoading(false);
        return sortedAddresses;
    };
    const sortedCustomerAddresses = (0, react_1.useMemo)(() => {
        var _a;
        if (addressBook === null || addressBook === void 0 ? void 0 : addressBook.customerAddresses) {
            return (_a = getSortedCustomerAddresses()) !== null && _a !== void 0 ? _a : [];
        }
        return [];
    }, [addressBook === null || addressBook === void 0 ? void 0 : addressBook.customerAddresses]);
    const handleAddAddressClick = () => {
        (0, router_1.navigate)(localizePath(CustomerAccount_1.CUSTOMER_ACCOUNT_PATH + exports.ADDRESS_BOOK_PATH + AddressForm_1.ADD_ADDRESS_FORM_PATH));
    };
    return (react_1.default.createElement("div", { className: "boutik-customer-account-address-book-container" },
        react_1.default.createElement("h1", { className: "boutik-customer-account-address-book-title" }, t("customerAccount.addressBook.sectionTitle")),
        react_1.default.createElement("div", { className: "boutik-customer-account-address-book-list-title-container" },
            react_1.default.createElement("h1", { className: "boutik-customer-account-address-book-list-title" }, t("customerAccount.addressBook.addressList.title")),
            react_1.default.createElement("div", { className: "boutik-customer-account-address-book-list-container" }, isLoading ? (react_1.default.createElement("div", { className: "boutik-customer-account-address-book-spinner-container" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: "boutik-customer-account-address-book-spinner", icon: pro_solid_svg_icons_1.faSpinnerThird, spin: true }))) : sortedCustomerAddresses.length > 0 ? (sortedCustomerAddresses.map((customerAddress, index) => (react_1.default.createElement(AddressBookListItem_1.AddressBookListItem, { key: `customer-address-${index}`, customerAddress: customerAddress })))) : (react_1.default.createElement("p", { className: "boutik-customer-account-address-book-list-no-addresses" }, t("customerAccount.addressBook.addressList.noAddresses"))))),
        react_1.default.createElement(Button_1.Button, { classNamePrefix: "boutik-customer-account-address-book-add-address", label: "customerAccount.addressBook.addAddressBtn", onClick: handleAddAddressClick })));
};
exports.AddressBook = AddressBook;
//# sourceMappingURL=AddressBook.js.map